// extracted by mini-css-extract-plugin
export default {"container":"Caa-z","oos":"Daa-z","oosUx":"Eaa-z","selected":"Faa-z","labelOos":"Gaa-z"};